var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6D6F71",
    d: "M50.073,22.98c-16.424,0-31.872,6.424-43.496,18.089c-0.473,0.475-0.472,1.247,0.003,1.72 c0.309,0.308,0.671,0.354,0.859,0.354c0.188,0,0.551-0.046,0.86-0.357C19.465,31.583,34.3,25.414,50.073,25.414 c15.698,0,30.482,6.119,41.63,17.23c0.31,0.309,0.671,0.355,0.858,0.355c0.188,0,0.551-0.046,0.861-0.357 c0.31-0.311,0.355-0.672,0.354-0.86c0-0.188-0.047-0.55-0.357-0.859C81.812,29.352,66.418,22.98,50.073,22.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6F71",
    d: "M50.073,37.16c-12.644,0-24.531,4.948-33.474,13.932c-0.473,0.475-0.472,1.247,0.003,1.721 c0.308,0.307,0.67,0.353,0.858,0.353c0.189,0,0.552-0.046,0.86-0.356c8.486-8.523,19.762-13.216,31.752-13.216 c11.916,0,23.141,4.642,31.609,13.071c0.31,0.309,0.67,0.354,0.856,0.354c0.189,0,0.553-0.047,0.864-0.358 c0.472-0.475,0.471-1.246-0.005-1.72C74.471,42.054,62.636,37.16,50.073,37.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6F71",
    d: "M50.073,51.339c-8.861,0-17.19,3.472-23.452,9.774c-0.31,0.312-0.355,0.673-0.354,0.861 c0,0.188,0.048,0.549,0.359,0.858c0.31,0.308,0.67,0.354,0.857,0.354c0.189,0,0.553-0.047,0.864-0.359 c5.803-5.84,13.519-9.056,21.727-9.056c8.133,0,15.8,3.166,21.588,8.915c0.309,0.307,0.669,0.353,0.856,0.353 c0.188,0,0.552-0.046,0.862-0.358c0.31-0.312,0.354-0.674,0.354-0.861c0-0.188-0.048-0.549-0.358-0.857 C67.129,54.756,58.854,51.339,50.073,51.339z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6F71",
    d: "M50,69.666c-2.027,0-3.677,1.649-3.677,3.677S47.972,77.02,50,77.02c2.028,0,3.677-1.649,3.677-3.677 S52.027,69.666,50,69.666z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.f5726232c191874a6c679bdcdfa98486.svg";
export { ForwardRef as ReactComponent };